import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, OverlayTrigger, Tooltip} from 'react-bootstrap';
import Options from '../../general/options';
import Criterials from '../../general/criterials';
import Unit from '../../general/unit';
import moment from 'moment';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import Inputmask from 'inputmask';
import SvgIcon from 'react-icons-kit';
import {notification} from 'react-icons-kit/icomoon/notification';


var Config = require('../../../../config');

class FromFractioning extends Component{
	constructor(props){
		super(props);
		this.getOption = this.getOption.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.getData = this.getData.bind(this);
		this.onChecked = this.onChecked.bind(this);
		this.onVolumeChange = this.onVolumeChange.bind(this);
		this.getValues = this.getValues.bind(this);
		this.removeFocus = this.removeFocus.bind(this);
		this.desfractioning = this.desfractioning.bind(this);
		this.checkAll = this.checkAll.bind(this);


		var aux_date = new Date();
		this.state = {
			option:"",
			equipment_list:[],
			equipment_id:"",

			date_form:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			hour:"",

			fractioning:[], 

			unit_check:[],
			header_tbl_components:[],

			blood_bags:[],
			division_program_id:"",
			donation_number:"",
			unit:{},
			multigesta:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		var selector = document.getElementById('hour');
		var im = new Inputmask("--:--");
		im.mask(selector);

		this.setState({option: "Block"});

		fetch(Config.default.apiGateway.URL+'equipments/by_health_facility?health_facilities_id='+
			sessionStorage.getItem("health_facilities_id")+'&type=fraccionador&active=true', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
			
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
	        }})
		.then(response => {
			this.setState({
				equipment_list: response
			})
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				hour:hours,
			});
		});

		this.getBloodBags();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getOption(option){
		this.setState({
			option:option,
			fractioning:[],
			unit_check:[]
		});

		if(option === 'Unit'){
			this.getBloodBags();
		}else{
			this.setState({blood_bags:[]});
		}
	}

	getBloodBags(){
		//blood_bags
		fetch(Config.default.apiGateway.URL+'blood_bags/by_hf/'+sessionStorage.getItem('health_facilities_id'), {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'	 	: 'application/json',
				'Content-Type' 	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			if(response !== undefined){
				this.setState({
					blood_bags: response
				});
			}						
		});
	}

	handleChange(e){
		var campo = e.target.name;
		this.setState({
			[campo]:e.target.value
		});

		if(e.target.name === 'hour'){

			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		
		}else{
			setTimeout(function(){
				this.showCtrlError(campo);
			}.bind(this), 500)
		}		
	}

	getData(result){
		if(result === undefined){
			result = []
		}
		this.setState({
			fractioning: result, 
			unit_check:[],
		});
		if(this.state.fractioning.length !== 0){
			var component = "";
			var unit = [];
			var header = [];
			
			result.headers_table.map((h, i)=>{
				header.push({
					title: result.headers_table[i].component,
					check: false,
					id: 'all_'+i,
					type: result.headers_table[i].type,
					repeated: false
				});	
			});

			for (var i = 0; i<result.headers_table.length; i++){
				var repeat= [];
				for (var j =i+1; j<result.headers_table.length; j++){

					if (result.headers_table[i].type == result.headers_table[j].type){
						header[i].check = false;
						header[i].repeated = true;
						header[j].check = false;
						header[j].repeated = true;

					}
				}
			}

			var blood_bags = this.criterials !== undefined ? this.criterials.state.blood_bags : this.state.blood_bags;
			var blood_bags_id = this.criterials !== undefined && this.criterials.state.blood_bags_id !== "" ? 
									this.criterials.state.blood_bags_id 
								: result.blood_bags_id;

			
			var multigesta = [];
			result.items.map((item, i)=>{
				var units = [];

				if(item.multigesta !== undefined){
					if(item.multigesta !== null && (item.multigesta === 1 || item.multigesta === "1")){
						multigesta.push(item.donation_number);
					}
				}else{
					if(result.multigesta !== null && (result.multigesta === 1 || result.multigesta === "1")){
						multigesta.push(item.donation_number);
					}
				}
					


				if(item.unit.length === undefined){
					
					item.donation_number = item.unit.unit.unit_number;

					item.unit = [item.unit];
				}else if(item.donation_number === ""){
					item.donation_number = item.unit[0].unit.unit_number;
				}

				blood_bags.map((b, x)=>{
					return b.blood_bag.id === parseInt(blood_bags_id) ?
						b.asigned_components.asigned.map((a, j)=>{
							
							var index = item.unit.findIndex(obj => 
								obj.blood_component.code === b.asigned_components.components[j].code &&
								(obj.unit !== undefined ?
									obj.unit.unit_number === item.donation_number
								: obj.u.unit_number === item.donation_number)
								
							)

							var index_vol = item.unit.findIndex(obj => 
								obj.blood_component.code === b.asigned_components.components[j].code &&
								(obj.unit !== undefined ?
									obj.unit.unit_number === item.donation_number &&
									obj.unit.current_unit
								: obj.u.unit_number === item.donation_number &&
									obj.u.current_unit)
							);
							
							return units.push({
								id 	  : a.blood_component_id+'_'+item.unit_st_id+'_'+j,
								check : header[j].repeated ?
											index !== -1 ?
												item.unit[index].unit !== undefined ?
													item.unit[index].unit.volume === "" ?
														false
													: true
												: item.unit[index].u.volume === "" ?
													false
												: true
											: false
										: index !== -1 ?
											item.unit[index].unit !== undefined ? 
												item.unit[index].unit.volume === "" ?
													false
												: true
											: item.unit[index].u.volume === "" ?
												false
											: true
										: false,
								volume: index !== -1 ?
											index_vol !== -1 ?
												item.unit[index_vol].unit !== undefined ?
													item.unit[index_vol].unit.volume 
												: item.unit[index_vol].u.volume
											: item.unit[index].unit !== undefined ?
												item.unit[index].unit.volume
											: item.unit[index].u.volume
										:a.volumen_regular,
								unit_id: item.unit_st_id,
								disable: item.unit.length > 0 ?
											/*item.unit[0].blood_component.code === 'ST' ? 
												false 
											: */index !== -1 ? true : false
										: false,
								division_program_id: item.division_program_id,
								donation_number:item.donation_number,
								type: header[j].type,
								repeated:header[j].repeated,
								enable:item.enable !== undefined ? item.enable : true,
								error:item.error !== undefined ? item.error : "",
							})

								
						})
							
					: null
				});


				unit.push({
					complete: item.division_completed !== undefined ? item.division_completed : result.division_completed,
					units: units
				});

				this.setState({
					donation_number: item.donation_number
				});
				
			});

			if(result.division_program_id !== 0 && this.state.option === 'Unit'){
				header.push({title:'', check:true});
			}

			this.state.fractioning.headers_table = header;
			this.forceUpdate();
			

			this.setState({
				unit_check: unit,
				multigesta:multigesta
			});

			if(this.state.option === 'Unit'){
				this.setState({
					division_program_id: result.division_program_id
				});
			}

		}

		setTimeout(function(){
			this.inputRef.focus();
		}.bind(this), 500);
	}

	onChecked(e){
		var id = e.target.id;
		var tipo = document.getElementById(id).getAttribute("tipo");
		var check = e.target.checked;

		this.state.unit_check.map((u, j)=>{
			u.units.map((item, i)=>{
				return item.repeated?
					check ?
						item.id.split('_')[1] === id.split('_')[1] &&
							item.id.split('_')[2] !== id.split('_')[2] && 
							item.type === tipo ?
							item.check ?
								item.check = false
							: null
						:item.id === id ?
							item.check = true
						: null
					: item.id === id ?
						item.check = false
					: null
				:item.id === id ?
					item.check = item.check ? false : true
				: null
			})
				
		});

		this.forceUpdate();
	}

	onVolumeChange(e){
		this.state.unit_check.map((u, i)=>{
			u.units.map((item)=>{
				if("fractioning_"+item.id === e.target.id){
					if(e.target.value.trim() === ''){
						item.volume = e.target.value
					}

					if(e.target.value.length < 4){
						if(e.target.value.indexOf('-') === -1){
							item.volume = e.target.value;
						}
						
					}
				}
				
			})
		});
		this.forceUpdate();
	}

	getValues(){
		var obj = [];
		var division = {};
		var error = 0;
		
		this.state.unit_check.map((u, j)=>{
			var part = {};
			var aux_division = [];
			var id = "";

			if(!u.complete){
				u.units.map((item, i)=>{
					if(item.check && !item.disable){
						part = {
							blood_component_id: parseInt(item.id.split('_')[0]),
							volumen: parseInt(item.volume),
							unit_id: parseInt(item.id.split('_')[1])
						}
						if(item.volume === null || item.volume === ""){
							error++;
						}else{
							aux_division.push(part);
						}

						id = item.division_program_id;
						
					}
				})

				var date = moment(this.state.date_form.split('-').reverse().join('/'), 'DD-MM-YYYY');
				var hour = moment(this.state.hour, 'h:mm a');

				if(aux_division.length !==0){
					obj.push({
						date : date.format('MM-DD-YYYY'),
						hour : this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm'),
						equipment_id : parseInt(this.state.equipment_id),
						division_parts : aux_division,
						id : id,
						donation_number:u.units[0].donation_number
					})
				}
			}
			
				
		});
	
		return obj;

		if(error !== 0){
			notify.show("Error, Debe ingresar un volumen en todos los componentes", 'error');
		}else{
			return division;
		}
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if (this.state[refName] === "") {


			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

  	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		for(var i = 0; i < form.elements.length; i++){
      			if(i >= index){
      				var id = form.elements[index].getAttribute("id");
      				var ids = id.split('_');
      				var col = 0;
      				
      				if(ids.length === 3){
      					col = ids[2];
      				}else if(ids.length === 4){
      					col = ids[3];
      				}


      				if(form.elements[i + 1] !== undefined){
      					if(form.elements[i+1].getAttribute("disabled") === null){
		      				/*if(form.elements[i+1].getAttribute("type") === 'checkbox'){
		      					var next_id = form.elements[i+1].getAttribute("id");
      							var next_ids = next_id.split('_');
      							var next_col = 0;

      							if(next_ids.length === 3){
			      					next_col = next_ids[2];
			      				}

			      				if(col === next_col){
			      					form.elements[i + 1].focus();
									form.elements[i + 1].style.boxShadow = "0 0 5px 2px rgb(104, 173, 253)";
									break;
			      				}

		      				}else{*/
		      					var next_id = form.elements[i+1].getAttribute("id");
		      					if(next_id !== null){
		      						var next_ids = next_id.split('_');
	      							var next_col = 0;

	      							if(next_ids.length === 4){
				      					next_col = next_ids[3];
				      				}

				      				if(col === next_col){
				      					form.elements[i + 1].focus();
				      					form.elements[i + 1].select();
										break;
				      				}
		      					}else{
		      						form.elements[i + 1].focus();
		      						break;
	      							
		      				//}
		      					}
		      			}else{
		      				continue;
		      			}
      				}
      			}
      		}

    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	removeFocus(e){
  		e.target.style.boxShadow = "0 0 5px 2px rgb(255, 255, 255)";
  	}

  	desfractioning(){
  		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea Desfraccionar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Desfraccionar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, function (isConfirm) {
	        if (isConfirm) {
	        	
	          	this.props.waiting.handleShow('Desfraccionando...');
				fetch(Config.default.apiGateway.URL+'division_program/'+this.state.division_program_id,{
					method: 'delete',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');	
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.unit.setState({
							unit_number: this.state.donation_number
						});

						this.unit.getFractioning();
						swal('Correcto', 'Desfraccionamiento realizado.', 'success');
					}
				})

				
				
	        }
	    }.bind(this));
  	}

  	checkAll(e){
  		var id = e.target.id;
  		var check = e.target.checked
  		var index = this.state.fractioning.headers_table.findIndex(obj => obj.id === id);
  		var tipo = this.state.fractioning.headers_table[index].type;

  		this.state.fractioning.headers_table.map((t)=>{
  			return t.repeated && t.type == tipo ?
  				check ?
  					t.id.split('_')[1] !== id.split('_')[1] ?
  						t.check = false
  					: t.check = true
  				: t.id === id ?
  					t.check = t.check ? false : true
  				: null
  			: t.id === id ?
  				t.check = t.check ? false : true
  			: null
  		})

  		
  		

  		this.state.unit_check.map((c)=>{
  			return c.units.map((dat)=>{
  				if(dat.enable){
  					if(dat.repeated && dat.type == tipo){
	  					if(check){
	  						if(dat.id.split('_')[2] !== id.split('_')[1] ){
		  						if(!dat.disable){
			  						dat.check = false
			  					}
	  						}else if(!dat.disable){
		  						if(check){
		  							dat.check = true
		  						}else{
		  							dat.check = false
		  						}
			  					
		  					}
	  					}else if(dat.id.split('_')[2] === id.split('_')[1]){
		  					if(!dat.disable){
		  						if(check){
		  							dat.check = true
		  						}else{
		  							dat.check = false
		  						}
		  					}
		  				}
	  				}else if(dat.id.split('_')[2] === id.split('_')[1]){
	  					if(!dat.disable){
	  						if(check){
	  							dat.check = true
	  						}else{
	  							dat.check = false
	  						}
	  					}
	  				}
  				}
	  				
  				
  			})
  		})

  		this.forceUpdate();

  	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12 form-group">
				<fieldset>
					<legend style={{fontSize:"1.5em", marginBottom:"5px"}}>Búsqueda</legend>
						<div className="col-xs-12 col-sm-1" style={{paddingRight:"0"}}>
							<Options {...this.props} validate={this.validateInput} sendData={this.getOption} onRef={ref => (this.options = ref)} />
						</div>

						<div className="col-xs-12 col-sm-11">
							{this.state.option === 'Unit' ?
								<Unit {...this.props} validate={this.validateInput} sendData={this.getData} onRef={ref => (this.unit = ref)} />
							: 	
								<Criterials {...this.props} validate={this.validateInput} sendData={this.getData} 
									onRef={ref => (this.criterials = ref)}  />
							}
						</div>							
				</fieldset>			

				<fieldset>
					<legend style={{fontSize:"1.5em", marginBottom:"10px"}}>Proceso</legend>

					<div className="col-xs-12 col-sm-9 col-sm-offset-1">
						<div className="col-xs-12 form-group" style={{paddingLeft:"3em"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right", paddingRight:"1em"}}>
								<span>Fecha</span>
							</div>
							<div className="col-xs-12 col-sm-2" style={{padding:"0", width:"17.5%"}}>
								<input className="form-control" type="date" id="date_form" name="date_form" ref={(input) => { this.inputRef = input }}
									onChange={this.handleChange} value={this.state.date_form || ""} onKeyPress={(e) => this.validateInput(e)} required />
							</div>

							<div className="col-xs-12 col-sm-1" style={{paddingLeft:"19px"}}>
								<span>Hora</span>
							</div>
							<div className="col-xs-12 col-sm-2" style={{padding:"0", width:"11.2%"}}>
								<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
									data-inputmask-placeholder="-" value={this.state.hour || ""} onChange={this.handleChange}
									required onKeyPress={(e)=>this.validateInput(e)} className="form-control"/>
							</div>
						</div>

						<div className="col-xs-12 form-group" style={{paddingLeft:"3em"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right", paddingRight:"1em"}}>
								<span>Fraccionador</span>
							</div>
							<div className="col-xs-12 col-sm-5" style={{padding:"0"}}>
								<select className="form-control" name="equipment_id" id="equipment_id" 
									style={{width:"89%"}}
									value={this.state.equipment_id || ""} onChange={this.handleChange} 
									onKeyPress={(e) => this.validateInput(e)}>
									<option value="">Seleccione...</option>
									{this.state.equipment_list.map((equip, i)=>(
										<option key={equip.id} value={equip.id}>{equip.name}</option>
									))}
								</select>
							</div>
						</div>

						<hr style={{width:"100%"}}/>
						<div className="col-xs-12 form-group">
							
							<Table responsive hover>
								<thead>
									<tr>
										<th>Donación</th>
										<th>Fecha</th>
										{this.state.fractioning.headers_table !== undefined ?
											this.state.fractioning.headers_table.map((header, i)=>{
												return <th key={i}> 
													{header.title !== '' && header.title !== undefined?
														<input type="checkbox" id={header.id} 
															onChange={this.checkAll} 
															style={{marginRight:"5px"}}
															checked={header.repeated !== undefined ?
																header.repeated.length > 0 ?
																	header.repeated[i] === i ?
																		false
																	: header.check
																: header.check
															: header.check}
															value={""} />
													: null}
												
													{header.title} 
													
												</th>
											})
										: null
										}
									</tr>
								</thead>
								<tbody>
								{this.state.fractioning.items !== undefined ?

									this.state.fractioning.items.length !== undefined ?
										this.state.fractioning.items.map((f, i)=>{
											return <tr key={i}>
														
												<td>{f.donation_number}</td>
												<td>{moment(f.timestamp_date).format('DD/MM/YYYY')}</td>
												{this.state.unit_check[i] !== undefined ?
													this.state.unit_check[i].units.map((u, i)=>{
														return <td key={i} style={{padding:"4px"}}>
															<span>
																<input type="checkbox" style={{marginRight:"5px"}} onChange={(e)=>this.onChecked(e)} 
																	onKeyPress={(e)=>this.validateInput(e)} id={u.id} checked={u.check} onBlur={this.removeFocus}
																	disabled={u.disable} tipo={u.type} />
																<input type="number" className="form-control volume-unit" style={{display:"inline-block", width:"70%"}}
																	id={"fractioning_"+u.id} onChange={(e)=>this.onVolumeChange(e)}
																	onKeyPress={(e) => this.validateInput(e)} value={u.volume || ""}
																	disabled={u.disable}/> ml
															</span>
														</td>
													})
												:null}

												{this.state.division_program_id !== 0 && this.state.option === 'Unit' ?
													<td>
														<button type="button" className="btn btn-info"
															onClick={this.desfractioning} >
															DESFRACCIONAR
														</button>
													</td>
												:null}
												{f.error !== "" && f.error !== undefined?
													<td>
														<OverlayTrigger
															placement="right"
															delay={{show:250, hide:400}}
															overlay={<Tooltip {...this.props}>{f.error}</Tooltip>}>
															<a href="#" onClick={e=>e.preventDefault()}>
																<SvgIcon icon={notification} 
																	size={15} 
																/>
															</a>
														</OverlayTrigger>
													</td>
												:null}
												
											</tr>
										})

									: null
								:null
								}
								
								</tbody>
							</Table>
						</div>
					</div>

					<Notifications />
				</fieldset>
			</div>

		)
	}
}

export default translate('translations')(FromFractioning);